import React, { useState } from "react";
import { SideMenu, EarningChart, ProgressChart } from "./../../components";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TotalEarningIcon from "./../../../assets/svg/totalEarningIcon.svg";
import TotalBookingIcon from "./../../../assets/svg/totalBookingIcon.svg";
import { Button } from "@mui/material";
import { BsArrowRight } from "react-icons/bs";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
const Dashboard = () => {
  const [selectedEvent, setSelectedEvent] = useState(0);
  const [content, setContent] = useState("");
  const [value, onChange] = useState(new Date());
  const EventList = [
    {
      title: "English Class",
      subTitle: "3rd Lesson",
      time: "18:00 - 19:30",
    },
    {
      title: "Maths Class",
      subTitle: "1st Lesson",
      time: "11:00 - 12:30",
    },
    {
      title: "Maths Class",
      subTitle: "2nd Lesson",
      time: "01:00 - 02:30",
    },
    {
      title: "Science",
      subTitle: "1st Lesson",
      time: "03:00 - 05:30",
    },
    {
      title: "English Class",
      subTitle: "2nd Lesson",
      time: "06:00 - 07:30",
    },
  ];
  return (
    <SideMenu>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xl={8} lg={8} md={12} sm={12} xs={12}>
            <div className="dashboard-first-section">
              <h1 className="dashboard-heading">Hello, David Anderson</h1>
              <div className="dashboard-earning-button-main">
                <Button className="dashboard-earning-button" variant="text">
                  <div className="dashboard-earning-button-icon">
                    <img src={TotalEarningIcon} />
                  </div>
                  <div className="dashboard-earning-button-data">
                    <p className="dashboard-earning-button-heading">
                      Total Earnings
                    </p>
                    <p className="dashboard-earning-button-price">$3,65,000</p>
                  </div>
                </Button>
                <Button className="dashboard-booking-button" variant="text">
                  <div className="dashboard-earning-button-icon">
                    <img src={TotalBookingIcon} />
                  </div>
                  <div className="dashboard-earning-button-data">
                    <p className="dashboard-booking-button-heading">
                      Total Complate Courses
                    </p>
                    <p className="dashboard-earning-button-price">1032</p>
                  </div>
                </Button>
              </div>
              <div className="dashboard-box-main">
                <div className="dashboard-chart-header">
                  <h1 className="dashboard-box-heading">Earnings</h1>
                  <select className="dashboard-filter-drowpdown">
                    <option>Weekly</option>
                    <option>Monthly</option>
                    <option>Yearly</option>
                  </select>
                </div>
                <div className="dashboard-chart-main">
                  <EarningChart />
                </div>
              </div>
              <div className="dashboard-box-main">
                <div className="dashboard-chart-header">
                  <h1 className="dashboard-box-heading">Your Progress</h1>
                </div>
                <div className="dashboard-chart-main">
                  <ProgressChart />
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xl={4} lg={4} md={12} sm={12} xs={12}>
            <div className="dashboard-second-section">
              <div>
                <Calendar onChange={onChange} value={value} />
              </div>
              <div className="dashboard-upcomming-class-main">
                <p className="dashboard-upcomming-class-heading">Upcomming</p>
                <Button
                  className="dashboard-upcomming-class-see-all-button"
                  variant="text"
                >
                  <p className="dashboard-upcomming-class-see-all-title">
                    see all
                  </p>
                  <BsArrowRight color="#303030" size={30} />
                </Button>
              </div>
              {EventList.map((eventValue, eventIndex) => {
                return (
                  <Button
                    className={
                      selectedEvent === eventIndex
                        ? "upcomming-class-selected-card"
                        : "upcomming-class-un-selected-card"
                    }
                    variant="text"
                    key={eventIndex}
                    onClick={() => setSelectedEvent(eventIndex)}
                  >
                    <div className="upcomming-class-card-list-main">
                      <p
                        className={
                          selectedEvent === eventIndex
                            ? "upcomming-class-selected-card-title"
                            : "upcomming-class-un-selected-card-title"
                        }
                      >
                        {eventValue.title}
                      </p>
                      <p
                        className={
                          selectedEvent === eventIndex
                            ? "upcomming-class-selected-card-sub-title"
                            : "upcomming-class-un-selected-card-sub-title"
                        }
                      >
                        {eventValue.subTitle}
                      </p>
                    </div>
                    <p
                      className={
                        selectedEvent === eventIndex
                          ? "upcomming-class-selected-card-time"
                          : "upcomming-class-un-selected-card-time"
                      }
                    >
                      {eventValue.time}
                    </p>
                  </Button>
                );
              })}
            </div>
          </Grid>
        </Grid>
      </Box>
    </SideMenu>
  );
};
export default Dashboard;
